import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HyperlinksRoutingModule } from './hyperlinks-routing.module';
import { HyperlinkComponent } from '@app/main/hyperlinks/hyperlink.component';
import { SharedModule } from '@shared/shared.module';

@NgModule({
    declarations: [HyperlinkComponent],
    imports: [CommonModule, SharedModule, HyperlinksRoutingModule]
})
export class HyperlinksModule {}
